// NAVIGATION CONSTANTS
export const HAMBURGER = 'HAMBURGER';
export const HORIZONTAL = 'HORIZONTAL';
export const TOPLEVEL = 'TOPLEVEL';
export const SUBLEVEL = 'SUBLEVEL';



// WEBPACK FOOTER //
// ./~/nucleus-widgets/lib/WebsiteNavigator/Constants.js